/* cvn-chat.js — the Shopify Inbox chat ("Online store chat" app embed) on phones (Zeus). Loaded once per page from
   snippets/header-drawer.

   WHAT IT DOES
   On phones (749px and down) there is NO floating chat bubble: it covered the page on the device where space is
   scarcest. Chat opens from "Chat with us" in the phone menu (snippets/header-drawer, [data-cvn-chat-open]),
   right-aligned on the "Log in" row. Tablets and desktop keep the bubble. The bubble's look (icon: Shopify's own
   chat bubble, colour, position) is NOT set here: it is the theme editor's App embeds → Online store chat. Inbox
   offers chat_bubble, team, hand_wave, email, question_mark and smiley_face; none is a headset.

   HOW. Inbox renders inside two OPEN shadow roots:
     shopify-chat > #shopify-element-wrapper > shopify-agent-runtime > … .activator-nudge > button.activator
   One <style> is added to the inner root, hiding the bubble at phone width; nothing of Inbox's is removed or
   rewritten, so its settings, panel and messages are untouched. The menu link opens chat by clicking Inbox's own
   button: .click() on a display:none button still runs its handler (verified: the panel opens as a sheet with
   its own Close). Inbox has no public open() API.

   ⚠ THIS REACHES INTO SHOPIFY'S WIDGET, WHICH SHOPIFY CAN CHANGE AT ANY TIME — AND IT FAILS SAFE. If the
   selectors stop matching, the bubble simply shows on phones again, and the menu link, finding no chat button,
   goes to /pages/contact instead. Nothing ends up hidden AND unreachable: the phone rule and the menu link key on
   the same button.
   ⚠ Inbox loads late and can re-render, so its root is watched and the style re-added whenever it is missing. */
(function () {
  if (window.cvnChatBound) return;
  window.cvnChatBound = true;

  var CSS = '@media (max-width: 749px){.activator-nudge{display:none!important}}';

  function inner() {
    var h = document.querySelector('shopify-chat');
    var a = h && h.shadowRoot;
    var rt = a && a.querySelector('shopify-agent-runtime');
    return (rt && rt.shadowRoot) || null;
  }
  function chatButton() { var r = inner(); return r ? r.querySelector('button.activator') : null; }

  var watched = null;
  function apply() {
    var r = inner();
    if (!r) return false;
    if (!r.getElementById('cvn-chat-style')) {
      var st = document.createElement('style');
      st.id = 'cvn-chat-style';
      st.textContent = CSS;
      r.appendChild(st);
    }
    if (watched !== r) {
      watched = r;
      try { new MutationObserver(function () { apply(); }).observe(r, { childList: true }); } catch (e) {}
    }
    return !!r.querySelector('button.activator');
  }

  /* Inbox mounts after the page: watch the body until it appears, then its own root keeps the style in place. */
  if (!apply()) {
    var bodyMo = null;
    try {
      bodyMo = new MutationObserver(function () { if (apply() && bodyMo) { bodyMo.disconnect(); bodyMo = null; } });
      bodyMo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    var tries = 0;
    var iv = setInterval(function () { if (apply() || ++tries > 40) clearInterval(iv); }, 500);
  }

  function closeDrawer() {
    try {
      var d = document.querySelector('header-drawer details[open], .menu-drawer-container[open]');
      var s = d && d.querySelector('summary');
      if (s) s.click();
    } catch (e) {}
  }

  /* "Chat with us" in the phone menu. Window CAPTURE, so it runs before the soft-nav loader's document-capture
     handler, which skips any click already defaultPrevented. No chat button = the link's own href (Contact). */
  window.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-cvn-chat-open]') : null;
    if (!a) return;
    var b = chatButton();
    if (!b) return;
    e.preventDefault();
    closeDrawer();
    setTimeout(function () { try { b.click(); } catch (err) { window.location.href = a.getAttribute('href') || '/pages/contact'; } }, 60);
  }, true);
})();
